import React from 'react'
import { useIntl } from "react-intl";
import styled from 'styled-components';
import { Button, Card, Col, Modal, Row } from 'react-bootstrap';
import { BsCalendarEvent, BsFillCupHotFill, BsX } from "react-icons/bs";

interface Props {
  show: boolean
  onClose: () => void
  onBreakTypeClick: () => void
  onEventTypeClick: () => void
}

export const ReservationPicker: React.FC<Props> = ({show, onClose, onBreakTypeClick, onEventTypeClick}) => {
  const intl = useIntl()
  return (
    <StyledModal show={show} onHide={onClose} centered size="lg" keyboard={true}>
      <Modal.Body className="px-5 pb-7 pt-4">
        <div className="d-flex justify-content-between align-items-center pb-5">
          <div className="fs-5 fw-bold">{intl.formatMessage({id: "calendar.reservation.picker.title"})}</div>
          <Button variant="outline-light" onClick={onClose} className="p-2 rounded-circle">
            <BsX size={40} color="black"/>
          </Button>
        </div>
        <Row>
          <Col>
            <StyledCard onClick={onEventTypeClick}>
              <Card.Body>
                <IconWrapper>
                  <BsCalendarEvent size={40}/>
                </IconWrapper>
                <div className="fw-bold fs-5">{intl.formatMessage({id: "calendar.reservation.picker.option.event"})}</div>
                <Description>{intl.formatMessage({id: 'calendar.reservation.picker.option.event.description'})}</Description>
              </Card.Body>
            </StyledCard>
          </Col>
          <Col>
            <StyledCard onClick={onBreakTypeClick}>
              <Card.Body>
                <IconWrapper>
                  <BsFillCupHotFill size={40}/>
                </IconWrapper>
                <div className="fw-bold fs-5">{intl.formatMessage({id: "calendar.reservation.picker.option.break"})}</div>
                <Description>{intl.formatMessage({id: 'calendar.reservation.picker.option.break.description'})}</Description>
              </Card.Body>
            </StyledCard>
          </Col>
        </Row>
      </Modal.Body>
    </StyledModal>
  )
}

const StyledModal = styled(Modal)`
  .modal-content {
    border-radius: 1rem;
  }
`;

const StyledCard = styled(Card)`
  cursor: pointer;
  box-shadow: none;
  padding-top: 3rem;
  border-radius: 1rem;
  padding-bottom: 3rem;
  border: 1px dashed var(--falcon-gray-400);

  &:hover {
    background-color: var(--falcon-gray-100);
  }

  .card-body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  justify-content: center;
`;

const Description = styled.div`
  font-size: 0.85rem;
  margin-bottom: 0.5rem;
  color: var(--falcon-gray-600);
`;
